<ng-container *ngIf="verificationCode">
    <mat-card class="dark:bg-contrast-black">
        <mat-card-content class="dark:bg-contrast-black">
            <h1 class="text-center dark:text-contrast-yellow">{{ verificationCode }}</h1>
            <ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
            </ridango-ui-basic-loading-spinner>
            <p class="text-center dark:text-contrast-yellow">{{ 'VERIFICATION_CODE_MESSAGE' | translate }}</p>
        </mat-card-content>
        <mat-card-actions class="full-width flex items-center">
            <button class="btn-secondary mr-16 w-16 lg:w-32" (click)="cancel()">
                {{ 'LOCAL_BTN_CANCEL' | translate }}
            </button>
        </mat-card-actions>
    </mat-card>
</ng-container>
